<template>
    <jet-form-section @submitted="saveBrandDrivers">
        <template #title>
            Add / Update Brand Drivers 
        </template>

        <template #description>
            
        </template>

        <template #form>
            <div class="col-span-6 sm:col-span-4">
                <select v-model="form.country" @change="getBrandDrivers">
                    <option disabled value="">Please select one</option>
                    <option v-for="country in countries" :value="country.country" :key="country.id">
                        {{ country.country }}
                    </option>
                </select>
                <jet-input-error :message="form.errors.country" class="mt-2" />
            </div>

            <div class="col-span-6 sm:col-span-4">
                <p><b>Drivers: </b></p>
                <label class="flex items-center">
                    <jet-checkbox :value="form.trust" v-model:checked="form.trust"/>
                    <span class="ml-2">Trust</span>
                </label>
                <label class="flex items-center">
                    <jet-checkbox :value="form.value" v-model:checked="form.value"/>
                    <span class="ml-2">Value</span>
                </label>
                <label class="flex items-center">
                    <jet-checkbox :value="form.experience" v-model:checked="form.experience"/>
                    <span class="ml-2">Experience</span>
                </label>
                <label class="flex items-center">
                    <jet-checkbox :value="form.relevance" v-model:checked="form.relevance"/>
                    <span class="ml-2">Relevance</span>
                </label>
                <label class="flex items-center">
                    <jet-checkbox :value="form.character" v-model:checked="form.character"/>
                    <span class="ml-2">Character</span>
                </label>
                <label class="flex items-center">
                    <jet-checkbox :value="form.progress" v-model:checked="form.progress"/>
                    <span class="ml-2">Progress</span>
                </label>
            </div>
        </template>

        <template #actions>
            <jet-action-message :on="form.recentlySuccessful" class="mr-3">
                Saved.
            </jet-action-message>

            <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                Save
            </jet-button>
        </template>
    </jet-form-section>
</template>

<script>
    import JetActionMessage from '@/Jetstream/ActionMessage'
    import JetCheckbox from '@/Jetstream/Checkbox'
    import JetButton from '@/Jetstream/Button'
    import JetFormSection from '@/Jetstream/FormSection'
    import JetInput from '@/Jetstream/Input'
    import JetInputError from '@/Jetstream/InputError'
    import JetLabel from '@/Jetstream/Label'

    export default {
        components: {
            JetActionMessage,
            JetCheckbox,
            JetButton,
            JetFormSection,
            JetInput,
            JetInputError,
            JetLabel,
        },

        props: ['countries'],

        data() {
            return {
                form: this.$inertia.form({
                    country: '',
                    trust: false,
                    value: false,
                    experience: false,
                    relevance: false,
                    character: false,
                    progress: false
                }),
            }
        },

        methods: {
            saveBrandDrivers() {
                this.form.put(route('brand-drivers-values.update'), {
                    errorBag: 'saveBD',
                    preserveScroll: true,
                    onSuccess: () => this.getBrandDrivers(),
                    onError: () => this.getBrandDrivers()
                })
            },
            getBrandDrivers() {
                let country = this.form.country
                axios.get('/api/brand-drivers-values/'+country)
                    .then((res) => {
                        this.form.reset();
                        this.form.country = country;
                        res.data.bd.forEach(element => {
                            this.form[element.toLowerCase()] = true
                        });
                    })
                    .catch((err) => {
                        window.location.reload();
                    })
            }
        },
    }
</script>
